import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import {
    Buttton,
    SelectO,
    Inputs,
    CustomDatePicker,
} from "../../../components";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { actionCommon, actionDoctor } from "../../../redux/actions";
import { useTranslation } from "react-i18next";
import { useAlert, useToast } from "../../../contexts";

const PersonalInformation = ({
    loginData,
    isEditVisible,
    getProfileInfoData,
    handleFormClick,
}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { showAlert } = useAlert();
    const { showToast } = useToast();
    const [credentials, setCredentials] = useState({
        userGuid: loginData.userGuid,
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        userType: loginData.userType,
        isVerified: loginData.isVerified,
        isEmailVerified: loginData.isEmailVerified,
        isMobileVerified: loginData.isMobileVerified,
        gender: "2",
        doB: "",
        citizenshipId: "",
        preferredLanguageIds: [],
        profileImage: "",
        profileImageURL: "",
        profileImagePath: "",
        timezoneGuid: "",
        address: "0",
        cancelReason: "",
        profileVerification: 0,
    });


    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setCredentials((prevCredentials) => ({
            ...prevCredentials,
            [name]: value,
        }));
        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };

            if (name === "firstName" && value.length >= 2) {
                delete updatedErrors.firstName;
            }
            if (name === "lastName" && value.length >= 2) {
                delete updatedErrors.lastName;
            }
            if (name === "email" && /\S+@\S+\.\S+/.test(value)) {
                delete updatedErrors.email;
            }

            return updatedErrors;
        });
    };

    const handleSelectChange = (name, selected) => {
        setCredentials((prevCredentials) => ({
            ...prevCredentials,
            [name]: selected.value,
        }));

        if (name === "languageId") {
            setSelectedLanguages(selected);
        } else if (name === "citizenshipId") {
            setSelectedCitizenshipId(selected);
        } else if (name === "timezoneGuid") {
            setSelectedTimeZoneGuid(selected);
        }

        if (name === "languageId" && selected) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                languageId: "",
            }));
        }

        if (name === "citizenshipId" && selected) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                citizenshipId: "",
            }));
        }

        if (name === "timezoneGuid" && selected) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                timezoneGuid: "",
            }));
        }
    };

    const handleSelectChange1 = (name, selected) => {
        const value = selected
            ? Array.isArray(selected)
                ? selected.map((option) => option.value)
                : selected.value
            : "";
        setCredentials((prevCredentials) => ({
            ...prevCredentials,
            [name]: value,
        }));
        setSelectedLanguages1(selected);
        if (name === "preferredLanguageIds" && selected.length > 0) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                preferredLanguageIds: "",
            }));
        }
    };



    useEffect(() => {
        dispatch(actionCommon.getWebsiteLanguageData());
        dispatch(actionCommon.getCountry());
        dispatch(actionCommon.getTimeZones());
    }, [dispatch]);

    const getWebsiteLanguageData = useSelector(
        (state) => state.common.getWebsiteLanguageData?.data
    );
    const getLanguagesData = useSelector(
        (state) => state.common.getLanguagesData?.data
    );
    const getCountryData = useSelector(
        (state) => state.common.getCountryData?.data
    );
    const getTimeZonesData = useSelector(
        (state) => state.common.getTimeZonesData?.data
    );

    const [options, setOptions] = useState([]);
    const [options1, setOptions1] = useState([]);
    const [options2, setOptions2] = useState([]);
    const [options3, setOptions3] = useState([]);
    const [dob, setDob] = useState();

    const [selectedLanguages, setSelectedLanguages] = useState(null);
    const [selectedLanguages1, setSelectedLanguages1] = useState([]);
    const [selectedCitizenshipId, setSelectedCitizenshipId] = useState(null);
    const [selectedTimeZoneGuid, setSelectedTimeZoneGuid] = useState(null);

    useEffect(() => {
        if (getProfileInfoData) {
            const data = getProfileInfoData.result;
            setCredentials((prevCredentials) => ({
                ...prevCredentials,
                firstName: data.firstName,
                lastName: data.lastName,
                email: data.email,
                phone: data.phone,
                languageId: data.languageId,
                gender: data.gender || 2,
                doB: data.doB,
                citizenshipId: data.citizenshipId,
                preferredLanguageIds: data.preferredLanguageIds,
                profileImage: data.profileImage,
                profileImageURL: data.profileImageURL,
                profileImagePath: data.profileImagePath,
                timezoneGuid: data.timezoneGuid,
            }));

            const selectedLanguage = options.find(
                (option) => option.value === data.languageId
            );
            setSelectedLanguages(selectedLanguage);

            const selectedLanguages1 = options1.filter((option) =>
                data.preferredLanguageIds.includes(option.value)
            );

            setSelectedLanguages1(selectedLanguages1);

            const selectedCitizenship = options2.find(
                (option) => option.value === data.citizenshipId
            );
            setSelectedCitizenshipId(selectedCitizenship);

            if (data.doB) {
                setDob(new Date(data.doB));
            }

            const selectedTimeZone = options3.find(
                (option) => option.value === data.timezoneGuid
            );
            setSelectedTimeZoneGuid(selectedTimeZone);
        }
    }, [getProfileInfoData, options, options1, options2, options3]);

    useEffect(() => {
        if (getWebsiteLanguageData) {
            const newOption = getWebsiteLanguageData.result.map((item) => ({
                value: item.languageId,
                label: item.languageName,
                abb: item.languageAbbreviation,
            }));
            setOptions(newOption);
        }
    }, [getWebsiteLanguageData]);

    useEffect(() => {
        if (getLanguagesData) {
            const newOption = getLanguagesData.result
                .filter((item) => item.isWebsiteLanguage === true)
                .map((item) => ({
                    value: item.languageId,
                    label: item.languageName,
                    abb: item.languageAbbreviation,
                }));
            setOptions1(newOption);
        }
    }, [getLanguagesData]);

    useEffect(() => {
        if (getCountryData) {
            const newOption = getCountryData.result.map((item) => ({
                value: item.countryID,
                label: item.countryName,
            }));
            setOptions2(newOption);
        }
    }, [getCountryData]);

    useEffect(() => {
        if (getTimeZonesData) {
            const newOption = getTimeZonesData.result.map((item) => ({
                value: item.timezoneGuid,
                label: item.displayName,
            }));
            setOptions3(newOption);
        }
    }, [getTimeZonesData]);

    const onSaveNext = () => {
        let newErrors = {};
        if (!credentials.languageId) {
            newErrors.languageId = t("please select language");
        }

        if (credentials.preferredLanguageIds.length === 0) {
            newErrors.preferredLanguageIds = t(
                "please select at least one supporting language"
            );
        }

        if (!credentials.firstName) {
            newErrors.firstName = t("* First name is required");
        } else if (credentials.firstName.length < 2) {
            newErrors.firstName = t("* First name must be at least 2 characters");
        }

        if (!credentials.lastName) {
            newErrors.lastName = t("* Last name is required");
        } else if (credentials.lastName.length < 2) {
            newErrors.lastName = t("* Last name must be at least 2 characters");
        }

        if (!credentials.email) {
            newErrors.email = t("* Email address is required");
        } else if (!/\S+@\S+\.\S+/.test(credentials.email)) {
            newErrors.email = t("* Email address must be valid");
        }

        if (!credentials.phone) {
            newErrors.phone = t("* Phone number is required");
        } else if (!/^\d{10}$/.test(credentials.phone)) {
            newErrors.phone = t("* Phone number must be 10 digits and only numbers");
        }

        if (!credentials.citizenshipId) {
            newErrors.citizenshipId = t("please select nationality");
        }

        if (!credentials.doB) {
            newErrors.doB = t("* Date of birth is required");
        }

        if (!credentials.timezoneGuid) {
            newErrors.timezoneGuid = t("please select time zone");
        }

        setErrors(newErrors);

        dispatch(
            actionDoctor.saveProfileInfo(credentials, (error, response) => {
                if (error) {
                    if (error.data) {
                        if (error.data.statusCode === 400) {
                            if (error.data.error && error.data.error.ValidationErrors) {
                                error.data.error.ValidationErrors.forEach((validationError) => {
                                    console.error(
                                        `${t("Field")}: ${validationError.Field} - ${t(
                                            "Message"
                                        )}: ${validationError.Message}`
                                    );

                                    showAlert(
                                        "danger",
                                        validationError.Message,
                                        `${t("Error")} : ${validationError.Field}`
                                    );
                                });
                            } else {
                                showAlert(
                                    "danger",
                                    `${t("Invalid_credentials")}`,
                                    `${t("Error")} !`
                                );
                            }
                        } else {
                            showAlert("danger", `${t("unexpected_error")}``${t("Error")} !`);
                        }
                    }
                } else if (response) {
                    if (response.status === 200) {
                        showToast(
                            t("success"),
                            t("profile_page.update_success_message"),
                            5000,
                            true,
                            "top-end toast-success"
                        );
                        const updatedFullName = `${credentials.firstName} ${credentials.lastName}`;
                        const doctorAccess =
                            JSON.parse(localStorage.getItem("doctor_access")) || {};
                        doctorAccess.fullName = updatedFullName;
                        doctorAccess.timeZoneId = selectedTimeZoneGuid.label;
                        doctorAccess.timezoneGuid = selectedTimeZoneGuid.value;

                        if (selectedLanguages) {
                            doctorAccess.languageId = selectedLanguages.value;
                            doctorAccess.languageAbb = selectedLanguages.abb;
                            localStorage.setItem("i18nextLng", selectedLanguages.abb);
                        }

                        localStorage.setItem("doctor_access", JSON.stringify(doctorAccess));

                        dispatch(actionDoctor.getProfileInfo(loginData.userGuid));
                        navigate("/doctor/my-profile/additional-information");
                    }
                }
            })
        );
    };

    return (
        <>
            <Form className="profile-form" onClick={handleFormClick}>
                <Row className="pro-row">
                    <Col md={6} className="pro-col">
                        <Form.Label className="exado-title-six">{t("Language")}</Form.Label>

                        <SelectO.SelectO
                            options={options}
                            onChange={(selected) =>
                                handleSelectChange("languageId", selected)
                            }
                            isSearchable={false}
                            name="languageId"
                            value={selectedLanguages}
                            className={`select1 ${errors.languageId ? "select-border-error" : ""
                                }`}
                            placeholder={t("Select") + " " + t("Language")}
                            isDisabled={!isEditVisible}
                        />
                        {errors.languageId && (
                            <Form.Text className="error-message noVerify">
                                {errors.languageId}
                            </Form.Text>
                        )}
                    </Col>
                    <Col md={6} className="pro-col">
                        <Form.Label className="exado-title-six">
                            {t("profile_page.supporting_language_for_consultation")}
                        </Form.Label>

                        <SelectO.SelectO
                            options={options1}
                            onChange={(selected) =>
                                handleSelectChange1("preferredLanguageIds", selected)
                            }
                            isMulti={true}
                            isSearchable={false}
                            name="preferredLanguageIds"
                            value={selectedLanguages1}
                            className={`select1 ${errors.preferredLanguageIds ? "select-border-error" : ""
                                }`}
                            placeholder={t("Select") + " " + t("Language")}
                            isDisabled={!isEditVisible}
                        />

                        {errors.preferredLanguageIds && (
                            <Form.Text className="error-message noVerify">
                                {errors.preferredLanguageIds}
                            </Form.Text>
                        )}
                    </Col>
                </Row>
                <Row className="pro-row">
                    <Form.Label className="exado-title-six">
                        {t("Personal")} {t("Information")}
                    </Form.Label>
                    <Col md={6} className="pro-col pi-col">
                        <Row>
                            <Inputs.FormInputs
                                placeholder={t("first_name")}
                                label={
                                    errors.firstName ? (
                                        <span className="error-message"> {errors.firstName}</span>
                                    ) : (
                                        t("first_name")
                                    )
                                }
                                name="firstName"
                                value={credentials.firstName}
                                onChange={handleChange}
                                // grpClassname="form-group form-group-error"
                                grpClassname={`form-group ${errors.firstName ? "form-group-error" : ""
                                    }`}
                                disabled={!isEditVisible}
                            />
                        </Row>
                    </Col>
                    <Col md={6} className="pro-col">
                        <Row>
                            <Inputs.FormInputs
                                placeholder={t("last_name")}
                                label={
                                    errors.lastName ? (
                                        <span className="error-message">{errors.lastName}</span>
                                    ) : (
                                        t("last_name")
                                    )
                                }
                                name="lastName"
                                value={credentials.lastName}
                                onChange={handleChange}
                                grpClassname={`form-group ${errors.lastName ? "form-group-error" : ""
                                    }`}
                                disabled={!isEditVisible}
                            />
                        </Row>
                    </Col>
                </Row>

                <Row className="pro-row">
                    <Form.Label className="exado-title-six">
                        {t("Contact")} {t("Information")}
                    </Form.Label>
                    <Col md={6} className="pi-col">
                        <Row>
                            <Inputs.FormInputs
                                placeholder={t("email") + " " + t("Address")}
                                label={
                                    errors.email ? (
                                        <span className="error-message">{errors.email}</span>
                                    ) : (
                                        t("email") + " " + t("Address")
                                    )
                                }
                                name="email"
                                value={credentials.email}
                                onChange={handleChange}
                                grpClassname={`form-group ${errors.email ? "form-group-error" : ""
                                    }`}
                                disabled={!isEditVisible}
                            />
                        </Row>
                    </Col>
                    <Col md={6}>
                        <Row>
                            <Inputs.FormInputs
                                placeholder={t("phone_number")}
                                // label={t("phone_number")}
                                label={
                                    errors.phone ? (
                                        <span className="error-message">{errors.phone}</span>
                                    ) : (
                                        t("phone_number")
                                    )
                                }
                                name="phone"
                                maxLength={10}
                                value={credentials.phone}
                                onChange={(e) => {
                                    const value = e.target.value.replace(/\D/g, "");
                                    setCredentials({
                                        ...credentials,
                                        phone: value,
                                    });
                                }}
                                grpClassname={`form-group ${errors.email ? "form-group-error" : ""
                                    }`}
                                disabled={!isEditVisible}
                            />
                        </Row>
                    </Col>
                </Row>

                <Row className="pro-row">
                    <Form.Label className="exado-title-six">{t("Gender")}</Form.Label>
                    <Col className="form-grp-radio-col">
                        <Inputs.CheckRadioInput
                            type="radio"
                            label={t("Female")}
                            name="gender"
                            className="form-grp-radio"
                            checked={credentials.gender === 2}
                            onChange={() => setCredentials({ ...credentials, gender: 2 })}
                            disabled={!isEditVisible}
                        />
                        <Inputs.CheckRadioInput
                            type="radio"
                            label={t("Male")}
                            name="gender"
                            className="form-grp-radio"
                            checked={credentials.gender === 1}
                            onChange={() => setCredentials({ ...credentials, gender: 1 })}
                            disabled={!isEditVisible}
                        />
                        <Inputs.CheckRadioInput
                            type="radio"
                            label={t("Other")}
                            name="gender"
                            className="form-grp-radio"
                            checked={credentials.gender === 3}
                            onChange={() => setCredentials({ ...credentials, gender: 3 })}
                            disabled={!isEditVisible}
                        />
                    </Col>
                </Row>
                <Row className="pro-row">
                    <Col md={6} className="pi-col">
                        <Form.Label className="exado-title-six">
                            {t("Nationality")}
                        </Form.Label>

                        <SelectO.SelectO
                            options={options2}
                            onChange={(selected) =>
                                handleSelectChange("citizenshipId", selected)
                            }
                            name="citizenshipId"
                            isSearchable={true}
                            value={selectedCitizenshipId}
                            className={`select1 ${errors.citizenshipId ? "select-border-error" : ""
                                }`}
                            placeholder={t("Select") + " " + t("Nationality")}
                            isDisabled={!isEditVisible}
                        />
                        {errors.citizenshipId && (
                            <Form.Text className="error-message noVerify">
                                {errors.citizenshipId}
                            </Form.Text>
                        )}
                    </Col>
                    <Col md={6} className="dob-col">
                        <Form.Label className="exado-title-six">
                            {t("Date_of_Birth")}
                        </Form.Label>

                        <fieldset
                            className={`frm-fieldset custom-date-picker ${errors.doB ? "error-date" : ""
                                }`}
                        >
                            <legend className="frm-legend">
                                {errors.doB ? (
                                    <span className="error-message">{errors.doB}</span>
                                ) : (
                                    t("Date_of_Birth")
                                )}
                            </legend>

                            <CustomDatePicker.CustomDatePickerDMY
                                selected={dob}
                                onChange={(date) => {
                                    const today = new Date();
                                    const isValidAge =
                                        date &&
                                        today.getFullYear() -
                                        date.getFullYear() -
                                        (today.getMonth() < date.getMonth() ||
                                            (today.getMonth() === date.getMonth() &&
                                                today.getDate() < date.getDate())
                                            ? 1
                                            : 0) >=
                                        18;

                                    if (!isValidAge) {
                                        showAlert(
                                            "danger",
                                            "You must be 18 or older",
                                            `${t("Error")}!`
                                        );
                                        setErrors((prevErrors) => ({
                                            ...prevErrors,
                                            doB: t("You_must_be_18_or_older"),
                                        }));
                                        return;
                                    }

                                    setDob(date);
                                    setCredentials((prevCredentials) => ({
                                        ...prevCredentials,
                                        doB: date ? date.toISOString() : "",
                                    }));

                                    // Clear any previous error when a valid date is selected
                                    setErrors((prevErrors) => ({
                                        ...prevErrors,
                                        doB: "",
                                    }));
                                }}
                                placeholderText="DD - MM - YYYY"
                                dateFormat="dd-MM-yyyy"
                                className="customDatePicker"
                                disabled={!isEditVisible}
                            />
                        </fieldset>
                    </Col>
                </Row>
                <Row className="pro-row">
                    <Col md="6">
                        <Form.Label className="exado-title-six">
                            {t("Time_Zone")}
                        </Form.Label>
                        <SelectO.SelectO
                            options={options3}
                            onChange={(selected) =>
                                handleSelectChange("timezoneGuid", selected)
                            }
                            name="timezoneGuid"
                            isSearchable={true}
                            value={selectedTimeZoneGuid}
                            className={`select1 ${errors.timezoneGuid ? "select-border-error" : ""
                                }`}
                            placeholder={t("Select") + " " + t("Time_Zone")}
                            isDisabled={!isEditVisible}
                        />
                        {errors.timezoneGuid && (
                            <Form.Text className="error-message noVerify">
                                {errors.timezoneGuid}
                            </Form.Text>
                        )}
                    </Col>
                </Row>
            </Form>
            <div className="profile-form-btn-blk">
                <Buttton.Buttton
                    children={t("CANCEL")}
                    className="btn-border-Aqua_Teal"
                />
                <Buttton.Buttton
                    children={`${t("SEND")} & ${t("NEXT")}`}
                    className=" btn-solid-Aqua_Teal"
                    onClick={onSaveNext}
                    disabled={!isEditVisible}
                />
            </div>
        </>
    );
};

export default PersonalInformation;
